import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { themes, getThemeByCompanyId, ThemeConfig } from '../../themes';

export const useThemeStore = defineStore(
  'theme',
  () => {
    // 当前主题ID
    const currentThemeId = ref<string>('default');

    // 当前主题配置
    const currentTheme = computed<ThemeConfig>(() => {
      return getThemeByCompanyId(currentThemeId.value);
    });

    // CSS变量映射 (已废弃，改用ConfigProvider组件)
    const cssVars = computed(() => {
      const theme = currentTheme.value;
      return {
        // 主色调
        '--theme-u-primary': theme.primary,
        '--theme-u-primary-light': theme.primaryLight,
        '--theme-u-primary-highlight': theme.primaryHighlight,
        '--theme-u-primary-navbar-bg': theme.primaryNavBarBgColor,

        // 渐变色
        '--theme-u-gradient-start': theme.gradientStart,
        '--theme-u-gradient-end': theme.gradientEnd,
        '--theme-u-gradient-background': theme.gradientBackground,

        // 功能色
        '--theme-u-success': theme.success,
        '--theme-u-success-light': theme.successLight,
        '--theme-u-warning': theme.warning,
        '--theme-u-warning-light': theme.warningLight,
        '--theme-u-error': theme.error,
        '--theme-u-error-dark': theme.errorDark,

        // 文本色
        '--theme-u-info': theme.info,
        '--theme-u-tip': theme.tip,
        '--theme-u-text-color-base': theme.textColorBase,
        '--theme-u-text-color-light': theme.textColorLight,
        '--theme-u-text-color-secondary': theme.textColorSecondary,

        // 背景色
        '--theme-u-bg-color': theme.bgColor,
        '--theme-u-card-bg-color': theme.cardBgColor,
        '--theme-u-border-color-custom': theme.borderColorCustom,

        // 阴影配置
        '--theme-u-shadow-light': theme.shadowLight,
        '--theme-u-shadow-medium': theme.shadowMedium,
        '--theme-u-shadow-heavy': theme.shadowHeavy,

        // 圆角配置
        '--theme-u-border-radius-small': theme.borderRadiusSmall,
        '--theme-u-border-radius-medium': theme.borderRadiusMedium,
        '--theme-u-border-radius-large': theme.borderRadiusLarge,
        '--theme-u-border-radius-card': theme.borderRadiusCard,
      };
    });

    // 切换主题
    const setTheme = (themeId: string = 'default') => {
      if (themes[themeId]) {
        currentThemeId.value = themeId;
        // 保存到本地存储
        uni.setStorageSync('theme_id', themeId);
      }
    };
    // 初始化主题
    const initTheme = () => {
      // 从本地存储读取主题
      const savedThemeId = uni.getStorageSync('theme_id');
      if (savedThemeId && themes[savedThemeId]) {
        currentThemeId.value = savedThemeId;
      }
    };

    // 获取所有可用主题
    const getAvailableThemes = () => {
      return Object.keys(themes).map(id => ({
        id,
        config: themes[id],
      }));
    };
    return {
      currentThemeId,
      currentTheme,
      cssVars,
      setTheme,
      initTheme,
      getAvailableThemes,
    };
  },
  {
    persist: {
      key: 'theme-store',
      storage: {
        getItem: (key: string) => uni.getStorageSync(key),
        setItem: (key: string, value: any) => uni.setStorageSync(key, value),
      },
    },
  },
);
